<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="panel panel-bordered mb-0">
        <div class="panel-heading">
          <h3 class="panel-title">Create Prize Pool</h3>
        </div>
        <div class="panel-body">
          <form class="form-horizontal">
            <div
              class="form-group row"
              :class="{ '.is-invalid': $v.name.$error }"
            >
              <label class="col-md-0 form-control-label form__label">
                <h5>Pool Name</h5>
              </label>
              <div class="col-md-12">
                <input
                  type="text"
                  ref="name"
                  class="form-control form__input"
                  v-model="name"
                  autocomplete="off"
                  @input="showValid('name')"
                />
                <nameValidation :$v="$v" v-if="showErrorNameValidation" />
              </div>
            </div>
            <div class="form-group row">
              <h5 class="col-md-12">Type</h5>
              <div class="col-md-12">
                <select
                  ref="type"
                  class="form-control col-md-12"
                  v-model="type"
                >
                  <option value="physical">Physical</option>
                  <option value="e-code">E-Code</option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div class="panel-footer">
          <div class="d-flex justify-content-between">
            <button
              type="button"
              class="btn btn-round btn-default mx-10"
              @click="close"
            >
              <i class="icon md-close" aria-hidden="true"></i>
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-round btn-primary"
              @click="createPrizePool"
              :disabled="$v.$invalid"
            >
              <i class="icon md-check" aria-hidden="true"></i> Create
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { prizepoolService } from "@/api/client";
import { responseErrorMapping } from "./model/error";
import nameValidation from "./validation/name";
import { FormCreateValidateRule as validateRules } from "./validation";

export default {
  name: "CreateModal",

  data() {
    return {
      showErrorNameValidation: false,
      name: "",
      type: "physical",
    };
  },

  components: {
    nameValidation,
  },

  validations: { name: validateRules.name },

  methods: {
    async isFormValid() {
      if (this.$v.name.$invalid) {
        await this.$dialogs.alert("กรุณากรอก Pool Name ให้ถูกต้อง");
        this.$refs.name.focus();
        return false;
      }
      return true;
    },

    close() {
      this.$modal.hide("create-prize-pool-modal");
    },

    async getFormData() {
      return {
        name: this.name,
        type: this.type,
      };
    },

    async createPrizePool() {
      try {
        const formValid = await this.isFormValid();
        if (!formValid) return;

        const body = await this.getFormData();

        await prizepoolService.createNewPrizePool(body);
        await this.$dialogs.alert("Create prize pool Success.");
        this.$emit("submit");
        this.close();
      } catch (error) {
        error.response
          ? this.$dialogs.alert(responseErrorMapping(error.response.data))
          : this.$dialogs.alert(error);
      }
    },

    showValid(name) {
      if (name == "name") {
        this.showErrorNameValidation = true;
      }
    },
  },
};
</script>
